<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/vertical-solutions']">
      <span translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>COMMONS.SERIAL_NUMBERS_GENERATION</span>
</div>

<tb-header specificTitle="COMMONS.SERIAL_NUMBERS_GENERATION"></tb-header>


<div class="contentGlobal" style="text-align: left">
<mat-card class="vertical-solution-card" style="text-align: center">
      <mat-card-header>
          <div style="display: flex; justify-content: space-between; width: 100%">
              <mat-card-title translate>COMMONS.SERIAL_NUMBERS_GENERATION</mat-card-title>
          </div>
      </mat-card-header>

      <mat-card-content>
        <div class="text-left" [innerHtml]="this.serialNumbersIntroduction"></div>
        <div style="margin-top: 3rem; display: flex; flex-direction: column; justify-content: flex-start" *ngIf="!noItems">
            <div>
                <mat-form-field appearance="outline">
                    <mat-label><span translate> VERTICAL_SOLUTIONS.CHOOSE_SOLUTION</span></mat-label>
                    <mat-select
                        ngModel
                        name="selectSolutionName"
                        [(ngModel)]="signatureSelected"
                        (selectionChange)="onSolutionChange($event)"
                    >
                        <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                        <mat-option *ngFor="let c of this.verticalSolutionList" [value]="c.Signature">
                          {{ c.Signature }} - {{ c.Description }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label><span translate>COMMONS.COUNTRY</span></mat-label>
                  <mat-select
                      ngModel
                      name="supportedContries"
                      (selectionChange)="onCountryChange($event)"
                      [(ngModel)]="this.countrySelected"
                      required
                  >
                      <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                      <mat-option *ngFor="let c of this.supportedCountriesList" [value]="c.CountryCode">
                          {{ c.CountryDescription }}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
            <div *ngIf="this.showEmbeddedItems" style=" display: flex; justify-content: space-between;padding-bottom: 1.2rem">
              <div>
                <mat-form-field appearance="outline">
                    <mat-label><span translate> VERTICAL_SOLUTIONS.CHOOSE_ITEMS</span></mat-label>
                    <mat-select ngModel name="selectItemCode" [(ngModel)]="selectedItemCode">
                        <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                        <mat-option *ngFor="let c of this.embeddedItemsList" [value]="c.ItemCode">
                            {{ c.Description }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
              <div>
                <button mat-flat-button color="primary" (click)="addItemCode()" [disabled]="setDisabled()">
                    <span translate>COMMONS.INSERT</span>
                </button>
              </div>
            </div>
            <div style="display: flex; justify-content: flex-start; flex-direction: row; padding-bottom: 1.2rem">
              <div style="padding-right: 2rem">
                <mat-form-field appearance="outline">
                  <mat-label translate>VERTICAL_SOLUTIONS.PRODUCTID_SHORTNAME</mat-label>
                  <input
                    matInput
                    #productShortModule
                    required
                    [maxLength]="4"
                    name="productShortName"
                    [formControl]="productShortNameControl"
                    style="text-transform:uppercase" />
                  <mat-hint>
                      <span class="mathintinputform" translate>COMMONS.INVALID_INPUT_MESSAGE_4_LETTER_NUMBER</span>
                  </mat-hint>
                  <mat-error *ngIf="!productShortModule.valid && productShortModule.touched"><span translate>COMMONS.INVALID_DATA_INPUT</span></mat-error>
                </mat-form-field>
              </div>
              <div style="padding-right: 2rem">
                <mat-form-field appearance="outline">
                    <mat-label translate>VERTICAL_SOLUTIONS.SALESMODULE_SHORTNAME</mat-label>
                    <input
                      matInput
                      #salesModuleShortModule
                      required
                      [maxLength]="4"
                      name="salesModuleShortName"
                      [formControl]="salesModuleShortNameControl"
                      style="text-transform:uppercase" />

                    <mat-hint>
                        <span class="mathintinputform" translate>COMMONS.INVALID_INPUT_MESSAGE_4_LETTER_NUMBER</span>
                    </mat-hint>
                    <mat-error *ngIf="!salesModuleShortModule.valid && salesModuleShortModule.touched"><span translate>COMMONS.INVALID_DATA_INPUT</span></mat-error>
                </mat-form-field>
              </div>
              <div style="padding-top: 0.5rem">
                <button mat-flat-button color="primary" (click)="addShortNames()" [disabled]="setShortNamesButtonDisabled()">
                    <span translate>COMMONS.INSERT</span>
                </button>
              </div>
            </div>
            <div *ngIf="tableFilesVisible"  class="table-upload">
                <div
                    *ngFor="let shortName of shortNamesList"
                    style="display: flex; flex-direction: row; justify-content: space-between"
                    class="table-upload-row">
                    <div style="display: flex; flex-direction: row">
                      <div style="min-width: 300px; padding: 0.8rem;text-align: left; ">{{ shortName.ProductID }}</div>
                      <div style="min-width: 300px; padding: 0.8rem; text-align: left;">{{ shortName.SalesModuleShortName }}</div>
                    </div>
                    <div style="min-width: 100px; padding: 0.3rem; float: right">
                        <button mat-mini-fab color="primary" class="upload-btn" (click)="deleteShortNames(shortName)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                  </div>
            </div>




            <div style="margin-top: 0.5rem; margin-left: 0.5rem; margin-top: 2rem;">

                    <button mat-flat-button color="primary" (click)="generateSerialNumber()" [disabled]="setGenerateSNDisabled()">
                        <span translate>COMMONS.SERIAL_NUMBERS_GENERATE</span>
                    </button>

            </div>
            <div *ngIf="false">
            <div *ngFor="let serialNumerItem of serialNumberList">
                <div>{{ serialNumerItem.ShortName }} -{{ serialNumerItem.Serials[0] }}</div>
            </div>
          </div>
        </div>
        <div *ngIf="showMessage" class="message-box error">
          <span>{{ this.messageBoxMessage }}</span>
        </div>
        <div class="message-box warning"  style="text-align: left" *ngIf="noItems">
          <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
        </div>
      </mat-card-content></mat-card
  >
</div>
<div *ngIf="this.loading">
<tb-loading></tb-loading>
</div>
